import { z } from 'zod';
import S3FileKind from '../enums/S3FileKind';
export var S3FileSchema = z.object({
    key: z.string(),
    kind: z.nativeEnum(S3FileKind)
});
